import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { Link } from "react-router-dom";
import Spinner from "../Spinner";
import { limitParagraphByCharLimit } from "../../Helper/Helper";

function CleanGridFacilities() {
  const [facilitiesData, setFacilitiesData] = useState([]);

  useEffect(() => {
    getFacilitiesData();
  }, []);

  const getFacilitiesData = async () => {
    const response = await SendPostRequest("facilities");
    setFacilitiesData(response?.data);
  };

  return (
    <>
      {facilitiesData?.length > 0 ? (
        <div id="portfolio-section" className="portfolio-section pad-top-20 pad-bottom-0">
          <div className="container">
            <div className="row">
              <div className="offset-md-2 col-md-8">
                <div className="title-wrap text-center">
                  <div className="section-title margin-bottom-60">
                    <h2 className="section-title margin-top-5 mb-0 text-uppercase">
                      Our <span className="theme-color">Facilities</span>
                    </h2>
                    <span className="section-border-bottom center"></span>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div
                  className="row portfolio-wrap portfolio-classic"
                  data-animation="fadeInDown"
                >
                  {facilitiesData?.length === 0 ? (
                    <div
                      style={{ marginBottom: "100px" }}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <Spinner />
                    </div>
                  ) : (
                    facilitiesData?.slice(0, 6)?.map((data, index) => (
                      <div
                        key={index}
                        className="portfolio-item portfolio-overlay-wrap col-lg-4 col-md-4 col-sm-4 col-xs-6 filter web animated fadeInLeft visible"
                      >
                        <div className="portfolio-thumb relative cleangrid-services-mobile-view">
                          <Link
                            to={`/facility/${data?.facility_slug
                              ?.replaceAll(" ", "-")
                              ?.replaceAll("/", "-")}`}
                          >
                            <img
                              src={data?.facility_image ||
                                "/assets/images/default.jpg"}
                              className="img-fluid"
                              alt={data?.facility_title}
                              style={{ height: "auto", width: "100%", objectFit: "cover" }}
                            />
                          </Link>
                          <div className="portfolio-wrap">
                            <div className="portfolio-details-overlay">
                              <Link
                                to={`/facility/${data?.facility_slug
                                  ?.replaceAll(" ", "-")
                                  ?.replaceAll("/", "-")}`}
                              >
                                <h3 className="mb-3 home-speciality-title-color">
                                  {data?.facility_title}
                                </h3>
                              </Link>
                              {/* <div className="portfolio-content">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: limitParagraphByCharLimit(
                                      data?.facility_short_description,
                                      100
                                    ) + "...",
                                  }}
                                />
                              </div> */}
                              <div className="portfolio-icons">
                                <Link
                                  to={`/facility/${data?.facility_slug
                                    ?.replaceAll(" ", "-")
                                    ?.replaceAll("/", "-")}`}
                                  className="link-icon"
                                >
                                  <i className="icon-link text-white"></i>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default CleanGridFacilities;